export const UPDATE_PASSWORD_AREA = 'update-password';
